var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "aimo-panel" }, [
    _c("div", { staticClass: "session-tabs" }, [
      _c(
        "button",
        {
          staticClass: "session-tab",
          class: { "is-active": _vm.activeTab === "latest" },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.activeTab = "latest"
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-history" }),
          _vm._v(" " + _vm._s(_vm.strings.latest) + "\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "session-tab",
          class: { "is-active": _vm.activeTab === "favorites" },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.activeTab = "favorites"
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-star" }),
          _vm._v(" " + _vm._s(_vm.strings.favourites) + "\n        "),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.activeTab === "latest"
      ? _c(
          "div",
          { staticClass: "session-list" },
          [
            _vm.latestRows.length === 0
              ? _c("div", { staticClass: "session-empty" }, [
                  _vm._v(_vm._s(_vm.strings.noConversations)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.latestRows, function (item) {
              return _c(
                "div",
                {
                  key: item.id === null ? "pending" : item.id,
                  staticClass: "session-item",
                  class: {
                    "is-active":
                      item.id === _vm.currentSessionId || item.pending,
                    "is-pending": item.pending,
                  },
                },
                [
                  item.pending
                    ? _c(
                        "button",
                        {
                          staticClass: "session-item-title",
                          attrs: { type: "button", disabled: "" },
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "session-item-title",
                          attrs: { type: "button", title: item.title },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("select", item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.title || _vm.strings.untitled))]
                      ),
                  _vm._v(" "),
                  !item.pending
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "session-icon-btn is-favorite-btn",
                            class: { "is-favorite": item.is_favorite },
                            attrs: {
                              type: "button",
                              title: item.is_favorite
                                ? _vm.strings.removeFromFavourites
                                : _vm.strings.addToFavourites,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$emit("toggle-favorite", item.id)
                              },
                            },
                          },
                          [
                            _c("i", {
                              class: item.is_favorite
                                ? "fas fa-star"
                                : "far fa-star",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "session-icon-btn is-delete",
                            attrs: {
                              type: "button",
                              title: _vm.strings.delete,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$emit("delete", item.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-trash" })]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "session-list" },
          [
            _vm.favorites.length === 0
              ? _c("div", { staticClass: "session-empty" }, [
                  _vm._v(_vm._s(_vm.strings.noFavourites)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.favorites, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "session-item",
                  class: { "is-active": item.id === _vm.currentSessionId },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "session-item-title",
                      attrs: { type: "button", title: item.title },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("select", item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.title || _vm.strings.untitled))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "session-icon-btn is-favorite-btn is-favorite",
                      attrs: {
                        type: "button",
                        title: _vm.strings.removeFromFavourites,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("toggle-favorite", item.id)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-star" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "session-icon-btn is-delete",
                      attrs: { type: "button", title: _vm.strings.delete },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("delete", item.id)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-trash" })]
                  ),
                ]
              )
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }